(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-alpenthermo-section]';

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function initHeader(section) {
    var ticking = false;

    function update() {
      section.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();

    section._atDestroyHeader = function () {
      window.removeEventListener('scroll', onScroll);
    };
  }

  function initMobileMenu(section) {
    var openButton = section.querySelector('[data-at-menu-open]');
    var closeButton = section.querySelector('[data-at-menu-close]');
    var menu = section.querySelector('[data-at-mobile-menu]');
    var links = section.querySelectorAll('[data-at-menu-link]');
    var lastFocused = null;

    if (!openButton || !closeButton || !menu) return;

    function openMenu() {
      lastFocused = document.activeElement;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    }

    function closeMenu(restoreFocus) {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (restoreFocus !== false && lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(event) {
      if (!menu.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu(true);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusable(menu);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function onResize() {
      if (window.innerWidth > 1100 && menu.classList.contains('is-open')) {
        closeMenu(false);
      }
    }

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', function () { closeMenu(true); });
    menu.addEventListener('keydown', onKeydown);
    window.addEventListener('resize', onResize);

    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function () { closeMenu(false); });
    });

    section._atDestroyMenu = function () {
      document.documentElement.style.overflow = '';
      window.removeEventListener('resize', onResize);
      menu.removeEventListener('keydown', onKeydown);
    };
  }

  function initFaq(section) {
    var list = section.querySelector('[data-at-faq-list]');
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('details'));

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initReveal(section) {
    var items = Array.prototype.slice.call(section.querySelectorAll('.at-reveal'));
    if (!items.length) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    section.classList.add('has-motion');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -36px 0px' }
    );

    items.forEach(function (item) { observer.observe(item); });
    section._atRevealObserver = observer;
  }

  function initSection(section) {
    if (!section || section.getAttribute('data-at-initialized') === 'true') return;

    section.setAttribute('data-at-initialized', 'true');
    initHeader(section);
    initMobileMenu(section);
    initFaq(section);
    initReveal(section);
  }

  function destroySection(section) {
    if (!section) return;
    if (section._atDestroyHeader) section._atDestroyHeader();
    if (section._atDestroyMenu) section._atDestroyMenu();
    if (section._atRevealObserver) section._atRevealObserver.disconnect();
  }

  function initAll(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(SECTION_SELECTOR)) initSection(scope);

    Array.prototype.forEach.call(scope.querySelectorAll(SECTION_SELECTOR), function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);
    destroySection(section);
  });
})();